import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ReduxToastr from 'react-redux-toastr';
import './index.scss';
import './toastr.scss';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import configureStore from './store';
import * as api from './api';
import { Route } from 'react-router-dom';
import { requireEtoAuthentication, AuthTokenObserver } from './auth';
import { TitleAnnouncer } from './layout';
import { AccessibilityNotificationComponent, accessibilityNotificationsEmitter } from './common';
import { featureHelpers } from './features';
import { history } from './history';
import { tenantHelpers } from './tenantInfo';
import { participantTypeHelpers } from './participant-types';

console.log("Initializing " + process.env.NODE_ENV + " environment");
const store = configureStore({});

api.config.store = store;
accessibilityNotificationsEmitter.store = store;
featureHelpers.store = store;
tenantHelpers.store = store;
participantTypeHelpers.store = store;
store.subscribe(AuthTokenObserver(store));

const intercomApplicationId = process.env.INTERCOM_APPLICATION_ID;
const { Intercom } = window;
const useIntercom = (intercomApplicationId && Intercom);
if (useIntercom) {
  Intercom('boot', {
    app_id: intercomApplicationId
  });
}

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <div>
      <TitleAnnouncer/>
      <ConnectedRouter history={history}>
        <Route path="/" component={requireEtoAuthentication(App)} />
      </ConnectedRouter>
      <div aria-live="polite">
        <ReduxToastr
          timeOut={6000}
          newestOnTop={false}
          preventDuplicates={true}
          position="top-right"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar />
      </div>
      <AccessibilityNotificationComponent/>
    </div>
  </Provider>
);
